import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import commonEn from '../locales/en/common.json';
import dashboardEn from '../locales/en/dashboard.json';
import assetsEn from '../locales/en/assets.json';
import settingsEn from '../locales/en/settings.json';

import commonHe from '../locales/he/common.json';
import dashboardHe from '../locales/he/dashboard.json';
import assetsHe from '../locales/he/assets.json';
import settingsHe from '../locales/he/settings.json';

const resources = {
  en: {
    common: commonEn,
    dashboard: dashboardEn,
    assets: assetsEn,
    settings: settingsEn
  },
  he: {
    common: commonHe,
    dashboard: dashboardHe,
    assets: assetsHe,
    settings: settingsHe
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'dashboard', 'assets', 'settings'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },

    interpolation: {
      escapeValue: false // React already escapes values
    },

    react: {
      useSuspense: false
    }
  });

export default i18n;
